<template>
  <b-popover
    :target="target"
    triggers="hover"
    placement="topleft"
    custom-class="kompack-topleft-popover"
  >{{ content }}</b-popover>
</template>

<script>
/**
 * A popover component that displays content when hovering over a target element.
 * The popover appears at the top-left position of the target element.
 * @component TopLeftPopover
 */
export default {
  props: {
    target: {
      required: true,
      type: String,
    },
    content: {
      required: true,
      type: String,
    },
  },
}
</script>

<style>
.kompack-topleft-popover.popover.b-popover.bs-popover-top .arrow::before,
.kompack-topleft-popover.popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::before,
.kompack-topleft-popover.popover.b-popover.bs-popover-top .arrow::after,
.kompack-topleft-popover.popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #F95031;
}
</style>
